import { render, staticRenderFns } from "./BannerIcons.vue?vue&type=template&id=049a6c40"
import script from "./BannerIcons.vue?vue&type=script&lang=js"
export * from "./BannerIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports